export const messageTemplate = [
    {
        name: 'Suspended',
        title: 'URGENT PAYMENT REQUEST',
        message: 'Camera access has been suspended.',
        customer_support: 'Customer Support: 1800870440'
    },
    {
        name: 'Suspend_Pending',
        title: 'URGENT PAYMENT REQUEST',
        message: 'Suspension of security camera pending.',
        customer_support: 'Customer Support: 1800870440'
    },
    {
        name: 'Removal_Today',
        title: 'URGENT',
        message: 'Due to 21 days non-payment of account your security camera is being removed today.',
        customer_support: 'To prevent removal Please call within next 30 min. 1800870440'
    },
    {
        name: 'Removal_Scheduled',
        title: 'URGENT PAYMENT REQUEST',
        message: 'Security camera scheduled for removal.',
        customer_support: 'Customer Support: 1800870440'
    },
    {
        name: 'Technician_Dispatched',
        title: 'GREAT NEWS!',
        message: 'A Myspy technician is on their way. We will update you as they progress.',
        customer_support: 'Customer Support: 1800870440'
    },
    {
        name: 'Job_Complete',
        title: 'GOOD NEWS!',
        message: 'Your security equipment is live and operational! Please refer to email for equipment access. Thank you for choosing Myspy Security!',
        customer_support: 'Customer Support: 1800870440'
    },
    {
        name: 'Service_Complete',
        title: 'Hi, your equipment has been serviced.',
        message: 'We apologise for any inconvenience caused. Please try accessing your equipment again. Thank you',
        customer_support: 'Customer Support: 1800870440'
    },
    {
        name: 'Technician_Arrived',
        title: 'TECHNICAL SUPPORT UPDATE.',
        message: 'A technician has arrived and is attending to your site security equipment. Allow approx 1 hour for the issue to be resolved.',
        customer_support: 'Customer Support: 1800870440'
    },
    {
        name: 'Custom Message',
        title: 'MYSPY UPDATE!',
        message: '',
        message: 'Great news, your camera(s) have been added to your DMMS account. Please refresh the app to view.',
        customer_support: 'Customer Support: 1800870440'
    },
];
